import { NavigationHelperService } from './../../../shared/helpers/navigation.helpers.service';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { DOCUMENT_WHITELIST } from '../../constants/constants';
import { ProductDocument } from '../../models/product-document.model';
import { Capacitor } from '@capacitor/core';
import { PLATFORM_CAPACITOR_TYPE } from 'src/app/shared/constants/platform-capacitor';
@Component({
  selector: 'app-product-detail-downloads',
  templateUrl: './product-detail-downloads.component.html',
  styleUrls: ['./product-detail-downloads.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailDownloadsComponent implements OnInit {
  @Input() isDisable = false;
  @Input() rawDocuments: { [key: string]: string };
  documentList: ProductDocument[] = [];
  constructor(private navigationHelperService: NavigationHelperService) {}
  ngOnInit() {
    this.documentList = Object.entries(this.rawDocuments)?.reduce(
      (list, document) => {
        if (DOCUMENT_WHITELIST[document[0]] && document[1]) {
          list = [
            ...list,
            {
              key: document[0],
              url: document[1],
              disable: this.isDisable,
              label: DOCUMENT_WHITELIST[document[0]].label,
            },
          ];
        }
        return list;
      },
      [],
    );
  }

  openFile(url: string) {
    const isIOSNativeApp =
      Capacitor.isNativePlatform() &&
      Capacitor.getPlatform() === PLATFORM_CAPACITOR_TYPE.IOS;

    isIOSNativeApp
      ? this.navigationHelperService.openDocumentPopoverCapacitor(url)
      : this.navigationHelperService.openDocumentInTabBrowser(url);
  }
}
